/**
 * Created by Christof Sander on 04.04.2017.
 */

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'propertiesForm'
	]
};